<template>
  <div class="customized-back-home" @click="$jump('/')">
    <img
      class="img"
      src="@/assets/images/customizedComponents/back_home_icon.png"
      alt=""
    />
    <span class="text">首页</span>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.customized-back-home {
  z-index: 999;
  position: fixed;
  right: 10px;
  bottom: 140px;
  width: 40px;
  height: 50px;
  background: rgba(0, 0, 0, 0.44);
  border-radius: 10px;
  .img {
    display: block;
    margin: 5px auto;
    width: 24px;
    height: 24px;
  }
  .text {
    display: block;
    margin: 2px auto;
    height: 12px;
    font-size: 10px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 12px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/customize/customizedComponents/BackHome.vue